<script>
export default {
  name: 'UploadFileV2',
  props: {
    idInput: {
      type: String,
      default: 'fileAccessClient',
    },
    value: {
      type: [File, Object],
    },
    types: {
      type: Array,
      default: () => {
        return []
      },
    },
    maxSize: {
      type: Number,
      default: 64,
    },
    label: {
      type: String,
      default: 'Selecione um arquivo para importar',
    },
    append: {
      type: Object,
      default: () => ({
        icon: '',
        text: 'Selecionar arquivo',
      }),
    },
    disabled: Boolean,
    multiple: Boolean,
  },
  data() {
    return {
      dragging: false,
    }
  },
  mounted() {
    this.clear()
  },
  methods: {
    clear({ emit = false } = {}) {
      if (emit) {
        this.$emit('input', null)
        this.$emit('change', null)
      }
      const el = this.$refs.input
      if (el) {
        el.value = null
      }
      this.dragging = false
    },
    onChangeFile(e) {
      if (this.disabled) {
        return
      }
      this.dragging = false
      if (
        (e.target && e.target.files) ||
        (e.dataTransfer && e.dataTransfer.files)
      ) {
        if (this.multiple) {
          const files = e.target ? e.target.files : e.dataTransfer.files
          if (files.length > 1) {
            // TODO: Fazer verificação de tamanho individualmente
            this.$emit('input', files)
            this.$emit('change', files)
            return
          }
        }
        let file = e.target ? e.target.files[0] : e.dataTransfer.files[0]

        const maxSizeLimit = this.maxSize || 64
        if (file && file.size / 1024 / 1024 > maxSizeLimit) {
          this.$showSnack({
            text: `Arquivo maior que o limite de ${maxSizeLimit} mb`,
            button: true,
          })
          return false
        }

        this.$emit('input', file)
        this.$emit('change', file)
      }
    },
  },
}
</script>

<template>
  <div class="upload-file-v2">
    <div class="upload-box">
      <div class="upload-box-main">
        <div
          class="drop-area"
          :class="{ 'drop-area-dragging': dragging && !disabled }"
          @ondragover="onChangeFile"
          @dragenter="dragging = true"
          @dragend="dragging = false"
          @dragleave="dragging = false"
        >
          <div
            class="drop-area-texts d-flex justify-content-between align-items-center"
          >
            <span class="text-heading-small text-color-900">
              {{
                dragging ? 'Solte para importar' : (value || {}).name || label
              }}
            </span>
            <div class="d-flex align-center">
              <icon-svg
                v-if="!value && append.icon"
                :name="append.icon"
                color="primary"
                class="mr-2"
              />
              <span
                v-if="!value"
                class="text-primary text-subtitle-small font-general-sans"
              >
                {{ append.text }}
              </span>
            </div>
            <div v-if="value" @click.prevent.stop>
              <v-btn
                icon
                small
                style="z-index: 2"
                :disabled="disabled"
                @click="clear({ emit: true })"
              >
                <v-icon small> mdi-close </v-icon>
              </v-btn>
            </div>
          </div>
          <input
            v-if="!disabled"
            :id="idInput"
            ref="input"
            type="file"
            :name="idInput"
            required
            :accept="types.join(', ')"
            :disabled="disabled"
            :readonly="disabled"
            :multiple="multiple"
            @change="onChangeFile"
          />
          <slot />
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="sass" scoped>
.upload-file-v2
  margin-top: 10px
  .upload-box .drop-area
    position: relative
    border-bottom: 2px solid #8E8E8E // !TODO: Se for no novo design, colocar todas as bordas
    border-radius: 2px
    height: 40px
    transition: all .3s ease

  .upload-box .drop-area input
    position: absolute
    cursor: pointer
    top: 0
    right: 0
    width: 100%
    height: 100%
    opacity: 0

  .upload-box .drop-area-dragging
    background-color: #ebebeb
    -webkit-box-shadow: 0 3px 6px 0 rgba(197, 191, 200, 0.13)
    box-shadow: 0 3px 6px 0 rgba(197, 191, 200, 0.13)
    border-width: 3px

  .upload-box .drop-area-texts
    // padding: 0 22px // !TODO: Se for no novo design, descomentar
    height: 100%

.new-ux
  .upload-box .drop-area
    border: 1px solid #8E8E8E
    border-radius: 4px

  .upload-box .drop-area-texts
    padding: 0 22px
</style>
